import * as MO from '@effect-ts/morphic'
const Term_ = MO.make(F =>
  F.interface(
    {
      id: F.number(),
      term: F.string()
    },
    { name: 'Term' }
  )
)

export interface Term extends MO.AType<typeof Term_> {}
export interface TermRaw extends MO.EType<typeof Term_> {}
export const Term = MO.opaque<TermRaw, Term>()(Term_)

const Terms_ = MO.make(F => F.array(Term(F)))
export interface Terms extends MO.AType<typeof Terms_> {}
export interface TermsRaw extends MO.EType<typeof Terms_> {}
export const Terms = MO.opaque<TermsRaw, Terms>()(Terms_)
